import { ModBox, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../AdminInputs'
import { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { TextInputWithInfo } from '../../screens/EntityOnboarding/OnboardEntity/comps/TextInputWithInfo'
import { Dropdown } from '../Dropdown'

const getDataList = (list: any[]) => {
  let dataList = []
  for (let i = 0; i < list?.length; i++) {
    dataList.push({
      id: list?.[i]?.mccCode,
      value: list?.[i]?.businessCategory,
      description: list?.[i]?.businessCategory,
    })
  }
  return dataList
}
const MccCode = ({
  isEdit,
  styles,
  prefilledMccCode,
  prefilledBizLine,
  prefilledBizCategory,
  setFieldValue,
  fieldName,
  coverFullWidth = false,
  childMarginRight = 0,
  dropDownMinHeight,
  labelType,
  textinputStyle = {},
  ...props
}: any) => {
  const {
    fetchMccProgramDetails,
    updateBusinessDetail,
    mccCodePrefilled,
    businessLinePrefilled,
    businessCategoryPrefilled,
    getAllBusinessLines,
    businessDetails,
  } = useStores((store) => ({
    fetchMccProgramDetails: store.fetchMccProgramDetails,
    updateBusinessDetail: store.onboarding.updateBusinessDetail,
    mccCodePrefilled: store.onboarding.businessDetail.mccCode,
    businessLinePrefilled: store.onboarding.businessDetail.businessLine,
    businessCategoryPrefilled: store.onboarding.businessDetail.businessCategory,
    getAllBusinessLines: store.getAllBusinessLines,
    businessDetails: store.onboarding.businessDetail,
  }))
  console.log('MccCode props', props)

  const [fetchMccProgramDetailsApi, { state, data: apiData }] = useLazyApiData(fetchMccProgramDetails)

  const [bizLineSelected, setBizLineSelected] = useState({
    key: '',
    value: '',
  })
  const [bizCategorySelected, setBizCategorySelected] = useState('')
  const [mccCode, setMccCode] = useState(prefilledMccCode)
  const [isLovCalled, setIsLovCalled] = useState(false)
  const [bizCategoryList, setBizCategoryList] = useState([])
  useEffect(() => {
    if (prefilledMccCode?.length > 0 && prefilledMccCode !== 'NA') {
      fetchMccProgramDetailsApi(prefilledMccCode, '')
    }
  }, [fetchMccProgramDetailsApi, prefilledMccCode])

  useEffect(() => {
    if (props?.allValues?.mccCodeComponent?.mccCode > 0) {
      setMccCode(props?.allValues?.mccCodeComponent?.mccCode)
      if (!props?.allValues?.mccCodeComponent?.businessCategory)
        fetchMccProgramDetailsApi(props?.allValues?.mccCodeComponent?.mccCode, '')
      else {
        setBizCategorySelected(props?.allValues?.mccCodeComponent?.businessCategory)
        setBizLineSelected(props?.allValues?.mccCodeComponent?.businessLine)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (state === 'fulfilled' && apiData !== undefined && mccCode?.length === 0) {
      setBizCategoryList(getDataList(apiData?.businessDetails))
    }
  }, [apiData, state, mccCode?.length])

  useEffect(() => {
    if (
      mccCodePrefilled &&
      mccCodePrefilled?.length === 4 &&
      businessLinePrefilled &&
      businessLinePrefilled?.length > 0 &&
      businessCategoryPrefilled &&
      businessCategoryPrefilled?.length > 0
    ) {
      setBizLineSelected({ key: businessLinePrefilled, value: businessLinePrefilled })
      setBizCategorySelected(businessCategoryPrefilled)
      setMccCode(mccCodePrefilled)
    }
  }, [businessCategoryPrefilled, businessLinePrefilled, mccCodePrefilled])

  useEffect(() => {
    if (
      state === 'fulfilled' &&
      bizCategorySelected === '' &&
      bizLineSelected.key === '' &&
      bizLineSelected.value === '' &&
      mccCode?.length === 4
    ) {
      if (apiData !== undefined) {
        const data = apiData
        updateBusinessDetail('businessLine', data?.businessLine)
        updateBusinessDetail('businessCategory', data?.businessDetails?.[0]?.businessCategory)
        updateBusinessDetail('mccCode', mccCode)
        setBizLineSelected({
          key: data?.businessLine,
          value: data?.businessLine,
        })
        setBizCategorySelected(data?.businessCategory)
        if (setFieldValue && fieldName) {
          setFieldValue(fieldName, {
            businessLine: {
              key: data?.businessLine,
              value: data?.businessLine,
            },
            businessCategory: data?.businessDetails?.[0]?.businessCategory,
            mccCode: mccCode,
          })
        }
      } else {
        setBizCategorySelected('')
        setBizLineSelected({ key: '', value: '' })
        setBizCategoryList([])
      }
    }
  }, [
    bizCategorySelected,
    bizLineSelected.key,
    bizLineSelected.value,
    fetchMccProgramDetailsApi,
    apiData,
    state,
    isLovCalled,
    mccCode,
    updateBusinessDetail,
  ])

  const handleOnMccCodechange = (mccCodeEntered: string) => {
    setMccCode(mccCodeEntered)
    setBizCategorySelected('')
    setBizLineSelected({ key: '', value: '' })
    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, {
        businessLine: { key: '', value: '' },
        businessCategory: '',
        mccCode: '',
      })
    }
    updateBusinessDetail('businessCategory', '')
    if (mccCodeEntered?.length === 4) {
      fetchMccProgramDetailsApi(mccCodeEntered)
    }
  }

  const onBizLineSelected = (businessLine: any) => {
    setBizCategorySelected('')
    setMccCode('')
    if (businessLine && businessLine?.length > 0 && businessLine !== bizLineSelected?.value) {
      fetchMccProgramDetailsApi('', businessLine)
      setMccCode('')
      setBizLineSelected({ key: businessLine, value: businessLine })
    }
  }

  const onBizCategorySelected = (businessCategory: any) => {
    if (businessCategory && businessCategory?.id?.length > 0) {
      setBizCategorySelected(businessCategory?.description)
      const mccCodeRet = businessCategory?.id !== undefined ? businessCategory?.id : prefilledMccCode
      setMccCode(mccCodeRet)
      if (setFieldValue && fieldName) {
        updateBusinessDetail('businessLine', bizLineSelected?.value)
        updateBusinessDetail('businessCategory', businessCategory?.description)
        updateBusinessDetail('mccCode', mccCodeRet)
        setFieldValue(fieldName, {
          businessLine: bizLineSelected,
          businessCategory: businessCategory?.description,
          mccCode: mccCodeRet,
        })
      }
    }
  }

  return (
    <ModBox w={'100%'}>
      <ModBox show={isEdit} direction="row" alignItems={'center'} justifyContent={'space-between'}>
        <ModBox minWidth={'24%'} flex={coverFullWidth ? 1 : undefined} paddingRight={childMarginRight}>
          <TextInputNew
            minWidth={'25%'}
            {...styles.textinputStyle(isEdit)}
            label="MCC Code"
            editable={true}
            maxLength={4}
            paddingHorizontal={isEdit ? 8 : undefined}
            onChange={handleOnMccCodechange}
            value={mccCode}
            error={props?.error?.mccCode}
            {...textinputStyle}
            touched={props?.touched}
          />
        </ModBox>
        <Spacer size={16} />
        <ModBox minWidth={'24%'} flex={coverFullWidth ? 1 : undefined} paddingRight={childMarginRight}>
          <Dropdown
            label={'Business Line'}
            title={'Select'}
            value={bizLineSelected?.value}
            data={isEdit ? getAllBusinessLines() : undefined}
            dataFieldToRead="description"
            type={'default'}
            testID={'businessLine'}
            selectedData={onBizLineSelected}
            textWidth={250}
            additionalWidth={380}
            fullWidthContent={true}
            minHeight={dropDownMinHeight}
            labelType={labelType}
            horizontalScroll
            error={bizLineSelected?.value?.length == 0 ? props?.error?.businessLine?.key : ''}
            touched={props?.touched}
          />
        </ModBox>
        <Spacer size={16} />
        <ModBox minWidth={'24%'} flex={coverFullWidth ? 1 : undefined}>
          <Dropdown
            label={'Business Category'}
            title={'Select'}
            value={bizCategorySelected && bizCategorySelected?.length > 0 ? bizCategorySelected : ''}
            data={isEdit ? bizCategoryList : undefined}
            dataFieldToRead="description"
            type={'default'}
            testID={'businessCategory'}
            selectedData={onBizCategorySelected}
            textWidth={250}
            passFullItemOnSelection={true}
            additionalWidth={300}
            fullWidthContent={true}
            horizontalScroll
            minHeight={dropDownMinHeight}
            labelType={labelType}
            error={props?.error?.businessCategory}
            touched={props?.touched}
          />
        </ModBox>
        <ModBox show={!coverFullWidth}>
          <Spacer size={16} />
          <ModBox minWidth={'24%'}>
            <Spacer size={'BIG'} />
          </ModBox>
        </ModBox>
      </ModBox>
      <ModBox show={!isEdit} direction="row" alignItems={'center'} justifyContent={'space-between'}>
        <ModBox minWidth={'24%'} flex={coverFullWidth ? 1 : undefined} paddingRight={childMarginRight}>
          <TextInputWithInfo
            minWidth={'24%'}
            fieldName={'mccCode'}
            allValues={{
              changeHistory: props?.allValues?.changeHistory?.mccCodeComponent,
            }}
            {...styles.textinputStyle(isEdit)}
            label="MCC Code"
            editable={false}
            maxLength={4}
            paddingHorizontal={isEdit ? 8 : undefined}
            onChange={handleOnMccCodechange}
            value={prefilledMccCode ? prefilledMccCode : mccCode}
            numberOfLines={4}
            multiline
          />
        </ModBox>
        <ModBox minWidth={'24%'} flex={coverFullWidth ? 1 : undefined} paddingRight={childMarginRight}>
          <TextInputNew
            {...styles.textinputStyle(isEdit)}
            label={'Business Line'}
            editable={false}
            paddingHorizontal={isEdit ? 8 : undefined}
            type="body12"
            value={bizLineSelected?.value ?? 'NA'}
            numberOfLines={4}
            multiline
            dataFieldToRead="description"
          />
        </ModBox>
        <ModBox minWidth={'24%'} flex={coverFullWidth ? 1 : undefined}>
          <TextInputNew
            minWidth={'24%'}
            {...styles.textinputStyle(isEdit)}
            label={'Business Category'}
            editable={false}
            paddingHorizontal={isEdit ? 8 : undefined}
            type="body12"
            value={bizCategorySelected ?? 'NA'}
            dataFieldToRead="description"
            numberOfLines={4}
            multiline
          />
        </ModBox>
        <ModBox minWidth={'24%'} show={!coverFullWidth}>
          <Spacer size={'BIG'} />
        </ModBox>
      </ModBox>
    </ModBox>
  )
}

export { MccCode }
